import { FormHelperText, Grid, InputAdornment, TextField } from "@mui/material";
import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import { UpdateMenuFlag } from "../../actions";
import setToast from '../../helpers/toaster.helper';
import { AppState } from '../../reducers/models';
import { UserService } from '../../services/UserService';
import PasswordRequirements from '../login/password-requriements.component';
import ButtonComponent from '../shared/button/button.component';
import { ActionLabels, appNote, buttonLabels, pageTitles, ToasterTexts } from '../shared/constants';
import DisplayContent from '../shared/display-content.component';
import { validateForm } from '../shared/form-validation';
import { ToasterType } from '../shared/toaster/toaster.model';
import { AppRoutes } from "../routes/route.path";
import { setHeaderTitle } from "../../helpers/header.helper";
import { BurgerMenuIcon, HidePassword, ShowPassword, SuccessIcon } from "../../icon";
import { useNavigate } from "react-router-dom";

interface IStateProps {
    IsMobileDevice: boolean;
    IsTeamsApp: boolean;
}

interface Props extends IStateProps, IDispatchProps { }

interface IDispatchProps {
    UpdateMenuFlag: (flag: boolean) => void;
}

const ChangePassword = (props: Props) => {
    const navigate = useNavigate()
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [errors, setErrors] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [isSuccess, setIsSuccess] = useState(false);
    const [showPasswordReq, setShowPasswordReq] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setHeaderTitle(pageTitles.CHANGE_PASSOWRD)
    }, [])

    const handleChange = (name: any, value: any) => {

        validateForm({ [name]: value }, (Errors) => {
            setErrors({ ...errors, ...Errors });
        });
    };

    const changePassword = (event: any) => {
        event.preventDefault();
        if (
            validateForm(
                {
                    currentPassword: currentPassword,
                    newPassword: {
                        newPassword: newPassword,
                        oldPassword: currentPassword,
                    },
                    confirmPassword: {
                        newPassword: newPassword,
                        confirmPassword: confirmPassword,
                    },
                },
                (Errors) => {
                    setErrors({ ...errors, ...Errors });
                }
            )
        ) {
            setIsLoading(true)
            const data = {
                newPassword: newPassword,
                oldPassword: currentPassword,
            };
            UserService.changePassword(data)
                .then((res) => {
                    setIsSuccess(true)
                    setIsLoading(true)
                    setErrors({ ...errors, currentPassword: "", newPassword: "", confirmPassword: "" })
                    setCurrentPassword("")
                    setNewPassword("")
                    setConfirmPassword("")
                    setToast(ToasterTexts.CHANGE_PASSWORD_SUCCESS, ToasterType.SUCCESS);
                })
                .catch((error) => {
                    setToast(error.response.data.message, ToasterType.DANGER);
                    setErrors({ ...errors, currentPassword: error.response.data.message, newPassword: "", confirmPassword: "" })
                    setIsLoading(false)
                });
        }
    };

    const isFormValid = () => {
        if (
            currentPassword !== newPassword &&
            !errors.confirmPassword &&
            !errors.currentPassword &&
            !errors.newPassword &&
            !!currentPassword &&
            !!newPassword &&
            !!confirmPassword
        ) {
            return false;
        }
        else return true;
    }
    // const showPasswordRequired = () => {
    //     setShowPasswordReq(!showPasswordReq)
    // };

    const onClickShowPassword = () => {
        setShowPassword(!showPassword)
    }
    const onClickShowNewPassword = () => {
        setShowNewPassword(!showNewPassword)
    }


    return (
        <div className={`w-p-100 bg-color-profile-primary-background ${props.IsMobileDevice ? "h-p-90" : "d-flex h-p-100 o-y-scroll"} ${(props.IsMobileDevice && props.IsTeamsApp) && "o-y-scroll"}`}>
            {props.IsMobileDevice && (
                <div className="d-flex w-fill px-2 p-absolute mt-2">
                    <span className="p-absolute my-auto" style={{ zIndex: 100 }} onClick={(e) => { e.stopPropagation(); props.UpdateMenuFlag(true) }}>
                        <BurgerMenuIcon />
                    </span>
                    <span className={"h1 ml-4 color-header-title-font"}>
                        {pageTitles.CHANGE_PASSOWRD}
                    </span>
                </div>
            )}
            <div
                className={`${props.IsMobileDevice
                    ? "paper-background h-p-100"
                    : `${!isSuccess ? "mx-p-12" : "mx-p-20"} settings-paper-border bg-color-profile-changepassword-box-border br-4 my-auto  w-fill `
                    } ${!isSuccess ? " h-fit d-flex" : "h-v-50 d-flex"} `}
            >
                {!isSuccess ? (
                    <form noValidate autoComplete="no"
                        className={`${props.IsMobileDevice ? "" : "w-fill"}`}
                        onSubmit={changePassword}>
                        <Grid container className="p-1" >
                            <Grid
                                container
                                direction="row"
                                spacing={0}
                                className={`${props.IsMobileDevice ? "w-p-100 mx-auto mt-2" : " "
                                    }`}
                            >
                                <Grid
                                    item
                                    xs={props.IsMobileDevice ? 12 : 6}
                                    className={`${props.IsMobileDevice ? "px-4 " : " px-4"}  `}
                                >
                                    <>
                                        {!props.IsMobileDevice}
                                        <div
                                            className={`${props.IsMobileDevice ? "mt-5 h4" : props.IsTeamsApp ? "mt-2 mb-3" : "mt-4 mb-3"} h2`}
                                        >
                                            <PasswordRequirements
                                                passwordCheck={newPassword}
                                                IsMobileDevice={props.IsMobileDevice}
                                            />
                                        </div>
                                    </>
                                </Grid>
                                <Grid item xs={props.IsMobileDevice ? 12 : 6} className={`${props.IsMobileDevice ? "px-4 mt-3" : props.IsTeamsApp ? "py-4 pr-4" : "py-4 pr-4"} `} >
                                    <div className={`${props.IsMobileDevice ? "h4 mb-1" : "h5-regular"} color-changepassword-fields-heading `}>Current Password *</div>
                                    <TextField
                                        autoFocus
                                        required
                                        type={showPassword ? "text" : "password"}
                                        fullWidth
                                        name="currentPassword"
                                        value={currentPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setCurrentPassword(e.target.value)
                                        }
                                        }
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end' onClick={onClickShowPassword} className="c-pointer">
                                                    {showPassword ? <HidePassword /> : <ShowPassword />}
                                                </InputAdornment>
                                            )
                                        }}
                                        FormHelperTextProps={{
                                            className: `h6 ${props.IsMobileDevice && "h5"}`,
                                        }}
                                        size="small"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.currentPassword ? "" : "mb-3"} `}>
                                        {errors.currentPassword}
                                    </FormHelperText>
                                    <div className={`${props.IsMobileDevice ? "h4 mb-1" : "h5-regular"} color-changepassword-fields-heading `}>New Password * </div>
                                    <TextField
                                        type={showNewPassword ? "text" : "password"}
                                        required
                                        fullWidth
                                        name="newPassword"
                                        value={newPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setNewPassword(e.target.value)
                                        }}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end' onClick={onClickShowNewPassword} className="c-pointer">
                                                    {showNewPassword ? <HidePassword /> : <ShowPassword />}
                                                </InputAdornment>
                                            )
                                        }}
                                        FormHelperTextProps={{
                                            className: `h6 ${props.IsMobileDevice && "h5"}`,
                                        }}
                                        size="small"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.newPassword ? "" : "mb-3"} `}>
                                        {!!newPassword && newPassword === currentPassword ? "Current password and new password should be different." : `${errors.newPassword}`}
                                    </FormHelperText>
                                    <div className={`${props.IsMobileDevice ? "h4 mb-1" : "h5-regular"} color-changepassword-fields-heading `}>Confirm Password *</div>
                                    <TextField
                                        required
                                        type="password"
                                        fullWidth
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setConfirmPassword(e.target.value)
                                        }}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        FormHelperTextProps={{
                                            className: `h6-regular ${props.IsMobileDevice && "h5-regular"}`,
                                        }}
                                        size="small"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.confirmPassword ? "mb-1" : "mb-4"} `}>
                                        {errors.confirmPassword}
                                    </FormHelperText>

                                    <Grid xs={12} item>
                                        <ButtonComponent
                                            ButtonLabel={ActionLabels.CHANGE_PASSWORD}
                                            Type={"submit"}
                                            ClassName={`c-pointer w-p-100 mb-2 d-flex justify-center ${props.IsMobileDevice ? "h2" : "h4-regular "
                                                }`}
                                            Variant={
                                                isFormValid()
                                                    ? "disabled-btn-small"
                                                    : "primary-btn-small"
                                            }
                                            Loading={isLoading}
                                        />
                                        <ButtonComponent Variant="secondary-btn" ClassName={`c-pointer w-p-100 h4-regular mt-2`} OnClick={() => navigate(-1)} ButtonLabel={buttonLabels.CANCEL} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                ) : (
                    <DisplayContent
                        btnClass={
                            "c-pointer d-block primary-btn justify-center f-custom-menuitem d-flex"
                        }
                        displayMsgClass={"h3-regular primary-accent-alt"}
                        cardTitleClass={`${props.IsMobileDevice ? "h1" : "h1-semibold"}`}
                        displayIcon={SuccessIcon}
                        cardTitle={appNote.PASSWORD_CHANGED}
                        displayMsg={appNote.CHANGEPASSWORD_SUCESS}
                        btnLabel={buttonLabels.BACK_TO_CONV_TEAMS}
                        btnPath={
                            AppRoutes.CONVERSATIONS
                        }
                        IsMobileDevice={props.IsMobileDevice}
                    />
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state: AppState): IStateProps => {
    return {
        ...state.Profile,
        IsMobileDevice: state.IsMobileDevice,
        IsTeamsApp: state.IsTeamsApp,
    };
};

const mapDispatchToProps = (dispatch: any): IDispatchProps => {
    return {
        UpdateMenuFlag: (flag: boolean) => UpdateMenuFlag(dispatch, flag),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)((ChangePassword));
